import { useEffect, useRef } from 'react';

/** Adds `scroll-margin-top` to the `<html/>` tag based on the height of the element mounted to the `ref`.
 *
 * This allows for easier scrolling via `element.scrollIntoView()` instead of having to calculate offset for each scroll. */
export function useNavbarScrollOffset<T extends HTMLElement>() {
    const navbarRef = useRef<T>(null);

    useEffect(() => {
        function setScrollOffset() {
            if (!navbarRef.current) return;

            const offset = navbarRef.current.getBoundingClientRect().height;

            document.documentElement.style.setProperty('scroll-padding-top', `${offset}px`);
        }

        setScrollOffset();

        window.addEventListener('resize', setScrollOffset);
        return () => window.removeEventListener('resize', setScrollOffset);
    }, []);

    return navbarRef;
}
